import { DocumentContentType, UserDto } from '../services/generated';
import { MyTaskDto } from '../services/generated/models/MyTaskDto';

export class MyTask implements MyTaskDto {
  public id: number;
  public title: string | null;
  public expiredDate: string | null;
  public documentId: string | null;
  public languageCode: string | null;
  public url: string;
  public content: string | null;
  public contentType: DocumentContentType | null;
  public created: string | null;
  public createdBy: UserDto | null;
  public contentTypeString: string = '';


  constructor(myTask: MyTaskDto) {
    this.id = myTask.id;
    this.title = myTask.title;
    this.expiredDate = myTask.expiredDate;
    this.documentId = myTask.documentId;
    this.languageCode = myTask.languageCode;
    this.url = myTask.url;
    this.content = myTask.content;
    this.contentType = myTask.contentType;
    this.created = myTask.created;
    this.createdBy = myTask.createdBy;
  

  Object.defineProperty(this, 'contentTypeString', {
    get() {
      switch (this.contentType) {
        case DocumentContentType.Document:
          return 'Document';
        case DocumentContentType.DocumentLink:
        case DocumentContentType.DynamicLink:
          return 'External document link';
      }
      return '';
    }
  });
}
}

    